import { Modal, Button, Form } from "react-bootstrap";

const EditStageModal = ({ show, handleClose, stageName, setStageName, onSave }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="stage-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Stage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          <Form.Group>
            <Form.Label>Edit Name *</Form.Label>
            <Form.Control
              value={stageName}
              onChange={(e) => setStageName(e.target.value)}
            />
          </Form.Group>

          <div className="footer-actions mt-4">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-orange" onClick={onSave}>
              Save Changes
            </Button>
          </div>

        </Form>
      </Modal.Body>
      <style>
          {
               `
               .stage-modal .modal-content {
  border-radius: 10px;
  padding: 10px;
}

.stage-modal .modal-header {
  border-bottom: 1px solid #eee;
}

.stage-modal .modal-footer {
  border-top: none;
}`
          }
      </style>
    </Modal>
  );
};

export default EditStageModal;